//author:gopikiran
//authgaurd service to secure routes
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard  {

  constructor(private _router: Router) {
  }

  canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let userObj =(localStorage.getItem('UserObj'));
    if (userObj) {
      return true;
    } else {
      this._router.navigate(['']);
    }
  }

}
